import { j as i } from "./atoms-v218.js";
import { Skeleton as n } from "./atoms-v21354.js";
function f(e) {
  return function(t) {
    return t.isLoading ? /* @__PURE__ */ i.jsx(n, { $height: t.height, $width: t.width }) : /* @__PURE__ */ i.jsx(e, { ...t });
  };
}
export {
  f as filledBlockSkeletonHOC
};
